"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessElement = exports.ScrollLockForBottomPlacement = exports.StepContainer = exports.UserRegistrationContainer = exports.ResendCode = exports.StyledSignIn = exports.StepPrompt = exports.ReceiveCodeWrapper = exports.HaveAnAccountWrapper = exports.PasswordRequirements = exports.Disclaimer = exports.GeneralError = exports.StyledButton = exports.StepSubheader = exports.StepHeader = exports.StepBody = exports.StepInnerContainer = exports.ButtonContainer = exports.CheckboxColumn = exports.SkipButtonContainer = exports.NewsletterTerms = exports.NewsletterContainer = exports.IndustryBodyContainer = exports.CheckboxContainer = void 0;
const componentlibrary_1 = require("@emarketer/componentlibrary");
const styled_components_1 = __importStar(require("styled-components"));
exports.CheckboxContainer = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  @media (max-width: 600px) {
    grid-template-columns: 1fr; // On smaller screens, switch to a single column
    width: 100%;
  }
  padding-bottom: 24px;
`;
exports.IndustryBodyContainer = styled_components_1.default.div `
  max-height: 180px;
  width: 100%;
  overflow-y: auto;
  margin-bottom: 32px;

  @media (min-width: 600px) {
    max-height: 624px;
    overflow-y: visible;
  }
`;
// When expanded, the newsletter container should be 500px tall that includes both button
// and newsletter list
exports.NewsletterContainer = styled_components_1.default.div `
  max-height: 350px;
  width: 100%;
  overflow-y: auto;
  margin-bottom: 8px;

  @media (min-width: 600px) {
    max-height: 430px;
    overflow-y: visible;
  }
`;
exports.NewsletterTerms = styled_components_1.default.p `
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  color: ${componentlibrary_1.COLOR.II.GRAY.DARK};
  padding: 8px 16px 24px 16px;
`;
exports.SkipButtonContainer = styled_components_1.default.div `
  margin-top: 32px;
  text-align: center;
`;
exports.CheckboxColumn = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 275px;
  @media (max-width: 600px) {
    width: 100%;
  }
`;
exports.ButtonContainer = styled_components_1.default.div `
  display: flex;
  gap: 16px;
  width: 100%;
  padding-top: 0px;
  @media (max-width: 600px) {
    padding-top: 8px;
  }
`;
exports.StepInnerContainer = styled_components_1.default.div `
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
exports.StepBody = styled_components_1.default.div `
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 24px;
`;
exports.StepHeader = styled_components_1.default.div `
  align-self: stretch;
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  line-height: 25px;

  @media (min-width: 600px) {
    font-size: 24px;
    line-height: 30px;
    padding-bottom: ${({ $hasSubheader }) => ($hasSubheader ? '16px' : '8px')};
  }
`;
exports.StepSubheader = styled_components_1.default.div `
  align-self: stretch;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 1.625;

  strong {
    font-weight: 700 !important;
  }

  @media (min-width: 600px) {
    font-size: 16px;
  }
`;
exports.StyledButton = (0, styled_components_1.default)(componentlibrary_1.Button) `
  background-color: ${({ $isDisabled }) => ($isDisabled ? componentlibrary_1.COLOR.II.GRAY.LIGHT : componentlibrary_1.COLOR.II.BLUE.DEFAULT)};

  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0em;
  width: 100%;
  padding: 16px 64px;
  border-radius: 25px;

  ${(props) => !props.$isCustom &&
    props.$isDisabled &&
    (0, styled_components_1.css) `
      color: ${componentlibrary_1.COLOR.II.GRAY.GRAY400} !important;
    `}

  ${(props) => !props.$isCustom &&
    !props.$isDisabled &&
    (0, styled_components_1.css) `
      color: ${componentlibrary_1.COLOR.II.WHITE} !important;
    `}
`;
/**
 * Styled component for displaying error on top of the page
 */
exports.GeneralError = styled_components_1.default.div `
  color: ${componentlibrary_1.COLOR.II.RED.DEFAULT};
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  padding-top: 8px;
  align-self: stretch;
  padding-bottom: 24px;
`;
exports.Disclaimer = styled_components_1.default.p `
  color: ${componentlibrary_1.COLOR.II.GRAY.DARK};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 19.5px;
  margin-top: 24px;
  max-width: 332px;

  @media (min-width: 600px) {
    margin-top: 32px;
    line-height: 22.75px;
    font-size: 14px;
  }
`;
exports.PasswordRequirements = styled_components_1.default.div `
  color: ${componentlibrary_1.COLOR.II.GRAY.DARK};
  padding: 0 24px;
  font-size: 14px;
  font-style: italic;
  font-weight: 300;
  line-height: 1.7;
  margin-top: -8px; // bottom padding for text-boxes is 24px, reduce that by 8px
  margin-bottom: 32px;
`;
exports.HaveAnAccountWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 48px;
`;
exports.ReceiveCodeWrapper = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 40px;
`;
exports.StepPrompt = styled_components_1.default.div `
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 23.14px;
`;
exports.StyledSignIn = (0, styled_components_1.default)(componentlibrary_1.A) `
  color: ${componentlibrary_1.COLOR.II.BLUE.DEFAULT};
  leading-trim: both;
  text-edge: cap;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 23.14px;
  text-decoration-line: underline;

  &:hover,
  &:focus {
    color: ${componentlibrary_1.COLOR.II.BLUE.DEFAULT} !important;
  }
`;
exports.ResendCode = (0, styled_components_1.default)(componentlibrary_1.Button) `
  color: ${componentlibrary_1.COLOR.II.BLUE.DEFAULT};
  leading-trim: both;
  text-edge: cap;
  font-size: 14px;
  font-style: normal;
  font-weight: ${({ $isHighlighted }) => ($isHighlighted ? 700 : 300)};
  line-height: 1.625;
  text-decoration-line: underline;

  &:hover,
  &:focus {
    color: ${componentlibrary_1.COLOR.II.BLUE.DEFAULT} !important;
  }

  /* Disabled during the resend cooldown; the extra :hover/:focus specificity beats the !important blue above */
  &:disabled,
  &:disabled:hover,
  &:disabled:focus {
    color: ${componentlibrary_1.COLOR.II.GRAY.GRAY400} !important;
    cursor: default;
    text-decoration-line: none;
  }
`;
exports.UserRegistrationContainer = styled_components_1.default.div `
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  font-display: swap;
  font-family:
    'Lab Grotesque', 'LabGrotesque-Regular', Arial, sans-serif; /* support for Gatsby by using LabGrotesque-Regular */
  color: ${componentlibrary_1.COLOR.II.BLACK};

  ${(props) => props.$registrationSource !== 'MarketingPages' &&
    (0, styled_components_1.css) `
      background-color: ${componentlibrary_1.COLOR.II.WHITE};
    `}

  ${(props) => props.$placement === 'bottom' &&
    (0, styled_components_1.css) `
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 10000;
      box-shadow: 0px -10px 24px 4px rgba(17, 17, 17, 0.1);
      padding: 40px 4px;
      height: 661px; /* Default height for mobile devices */

      @media (min-width: 600px) {
        height: 624px;
        padding-top: 48px;
        padding-bottom: 40px;
      }
    `}

  ${(props) => props.$placement === 'full-page' &&
    (0, styled_components_1.css) `
      min-height: 100vh;
      box-sizing: border-box;
      justify-content: center;
    `}
`;
exports.StepContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 586px;

  @media (max-width: 600px) {
    padding: 0 24px;
  }
`;
/**
 * Lock scrolling on the page when the user registration is displayed at the bottom of the page.
 * "position: fixed" is used specifically to prevent scrolling on Safari mobile (iOS, iPadOS).
 * Please note that this locks everything so, if you need to make things scrollable, you need to implement the scroll on the affected element(s).
 */
exports.ScrollLockForBottomPlacement = (0, styled_components_1.createGlobalStyle) `
  body {
    ${(props) => props.$placement === 'bottom' &&
    (0, styled_components_1.css) `
        overflow: hidden;
        position: fixed;
        width: 100%;
      `}
  }
`;
exports.SuccessElement = styled_components_1.default.div `
  display: flex;
  flex-basis: 100%;
  justify-content: center;
  align-items: center;
  gap: 8px;

  span {
    font-size: 14px;
    font-weight: 700;
  }
`;
